var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dashboardItemEnabled)?_c('div',{staticClass:"vue-dashboard-item",style:(_vm.rowstyles)},[_c(_vm.dashboardComponent,{tag:"component",attrs:{"dashboard-id":_vm.dashboardId,"item-config":_vm.itemConfig}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }